import { Injectable } from '@angular/core';
import { AuthorizationRequestConfigurationService } from './authorization-request-configuration/authorization-request-configuration.service';
import { LogoutConfigurationService } from './logout/logout-configuration.service';
import { ResetPasswordConfigurationService } from './reset-password/reset-password-configuration.service';
import { ClientConfigurationService } from './client/client-configuration.service';
import { AuthorizationCodeRequestConfigurationService } from './authorization-code-request-configuration/authorization-code-request-configuration.service';
import { RefreshTokenConfigurationService } from './refresh-token/refresh-token-configuration.service';
import { ConfigurationModule } from '../configuration.module';
import { AuthConfiguration } from './auth-configuration';
import { PKCEConfigurationService } from './p-k-c-e/p-k-c-e-configuration.service';
import { AuthorityConfigurationService } from './authority/authority-configuration.service';

@Injectable({
  providedIn: ConfigurationModule
})
export class AuthConfigurationService {

  get configuration(): AuthConfiguration {
    return {
      login: this.authorizationRequestConfigurationService.configuration,
      logout: this.logoutConfigurationService.configuration,
      resetPassword: this.resetPasswordConfigurationService.configuration,
      client: this.clientConfigurationService.configuration,
      pkce: this.pkceConfigurationService.configuration,
      refresh_token: this.refreshTokenConfigurationService.configuration,
      token: this.authorizationCodeRequestConfigurationService.configuration,
      authority: this.authorityConfigurationService.configurations,
      access_token_expires_in_offset: this.access_token_expires_in_offset
    };
  }

  loaded;

  access_token_expires_in_offset;

  constructor(private authorizationRequestConfigurationService: AuthorizationRequestConfigurationService,
    private logoutConfigurationService: LogoutConfigurationService,
    private resetPasswordConfigurationService: ResetPasswordConfigurationService,
    private authorizationCodeRequestConfigurationService: AuthorizationCodeRequestConfigurationService,
    private refreshTokenConfigurationService: RefreshTokenConfigurationService,
    private clientConfigurationService: ClientConfigurationService,
    private pkceConfigurationService: PKCEConfigurationService,
    private authorityConfigurationService: AuthorityConfigurationService) { }

  loadConfiguration(configuration) {
    this.access_token_expires_in_offset = 300;
    this.loadAuthorityConfigurations(configuration.authority);
    this.loadClientConfiguration(configuration.client);
    this.loadLoginConfiguration(configuration.login);
    this.loadLogoutConfiguration(configuration.logout);
    this.loadTokenConfiguration(configuration.token);
    this.loadRefreshTokenConfiguration(configuration.refresh_token);
    this.loadResetPasswordConfiguration(configuration.resetPassword);
    this.loadPKCEConfiguration(configuration.pkce);
  }

  loadAuthorityConfigurations(configurations) {
    this.authorityConfigurationService.loadConfigurations(configurations);
  }

  loadLoginConfiguration(configuration) {
    this.authorizationRequestConfigurationService.loadConfiguration(configuration);
  }

  loadLogoutConfiguration(configuration) {
    this.logoutConfigurationService.loadConfiguration(configuration);
  }

  loadTokenConfiguration(configuration) {
    this.authorizationCodeRequestConfigurationService.loadConfiguration(configuration);
  }

  loadRefreshTokenConfiguration(configuration) {
    this.refreshTokenConfigurationService.loadConfiguration(configuration);
  }

  loadResetPasswordConfiguration(configuration) {
    this.resetPasswordConfigurationService.loadConfiguration(configuration);
  }

  loadClientConfiguration(configuration) {
    this.clientConfigurationService.loadConfiguration(configuration);
  }

  loadPKCEConfiguration(configuration) {
    this.pkceConfigurationService.loadConfiguration(configuration);
  }
}
